import { useGetTeams } from 'api';
import { manageTeamsRequestState, manageTeamPageNumberState } from 'store';
import { PaginationInfo, Team } from 'types';

export type useGetManageTeamRecordsReturn = {
  data: Team[];
  totalCount: number;
  paginationInfo: PaginationInfo | undefined;
};

export const useGetManageTeamRecords = (): useGetManageTeamRecordsReturn => {
  const { data: teamsResponse } = useGetTeams(
    manageTeamsRequestState,
    manageTeamPageNumberState
  );

  const teams = teamsResponse?.teams?.items ?? [];
  const totalCount = teams?.length ?? 0;

  return {
    data: teams,
    totalCount,
    paginationInfo: teamsResponse?.paginationInfo,
  };
};
